module.exports = __webpack_public_path__ + "static/media/b-friday-sm.f97917f5.gif";